import api from './api'

/**
 * Activity API service
 */
export const activityAPI = {
    /**
     * Fetch all activities for the authenticated user
     * @returns {Promise<Object>} Activities data
     */
    fetchActivities: async () => {
        const response = await api.get('/activities')
        return response.data
    },

    /**
     * Create activity from GPX file upload
     * @param {FormData} formData - Form data containing gpxFile, title, duration, distance, completed_at
     * @returns {Promise<Object>} Created activity and updated user stats
     */
    createActivityFromGPX: async (formData) => {
        const response = await api.post('/activities/gpx', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
        return response.data
    },

    /**
     * Create activity from existing route
     * @param {Object} payload - Activity data including route_id, title, distance, duration, completed_at
     * @returns {Promise<Object>} Created activity and updated user stats
     */
    createActivityFromRoute: async (payload) => {
        const response = await api.post('/activities', payload)
        return response.data
    },

    /**
     * Update an activity
     * @param {string} id - Activity ID
     * @param {Object} payload - Update data (title, distance, duration, completed_at)
     * @returns {Promise<Object>} Updated activity and user stats
     */
    updateActivity: async (id, payload) => {
        const response = await api.put(`/activities/${id}`, payload)
        return response.data
    },

    /**
     * Delete an activity by ID
     * @param {string} id - Activity ID
     * @returns {Promise<Object>} Deletion response
     */
    deleteActivity: async (id) => {
        const response = await api.delete(`/activities/${id}`)
        return response.data
    },
}

export default activityAPI
